import React, { useState } from "react";
import Web3Modal from "web3modal";
import { BrowserProvider, Contract, parseEther } from "ethers";


const providerOptions = {
    walletconnect: {
      package: require("@walletconnect/web3-provider"),
      options: { infuraId: process.env.REACT_APP_INFURA_ID },
    },
  };
  

const WalletConnect = ({ setSigner }) => {
  const [address, setAddress] = useState("");

  const connectWallet = async () => {
    try {
      const web3Modal = new Web3Modal({ cacheProvider: true, providerOptions });
      const instance = await web3Modal.connect();
      const provider = new BrowserProvider(instance);
      
      // ✅ Use `provider.getSigner()` properly in ethers v6
      const signer = await provider.getSigner();
  
      // ✅ Get the wallet address correctly in ethers v6
      const address = await signer.getAddress();
      console.log("Connected Wallet:", address);
  
      setSigner(signer);
    } catch (error) {
      console.error("Wallet connection failed:", error);
    }
  };
  

  return (
    <div>
      {address ? (
        <p>Connected: {address.slice(0, 6)}...{address.slice(-4)}</p>
      ) : (
        <button onClick={connectWallet}>Connect Wallet</button>
      )}
    </div>
  );
};

export default WalletConnect;
